// src/components/Button.jsx
import React from 'react';
import { GoArrowUpRight } from "react-icons/go";

const Button = ({ text, onClick, type = "button", className = "" }) => {
    return (
        <>
            <button onClick={onClick} className="flex items-center justify-center space-x-3 hover:bg-[#003366] px-6 py-3 rounded-md text-white text-base cursor-pointer bgcolor w-full">
                <h1>{text}</h1>
                <GoArrowUpRight className="w-5 h-5 text-white" />
            </button>
        </>

    );
};

export default Button;